import { render, staticRenderFns } from "./blockAction.vue?vue&type=template&id=c38cfbba"
import script from "./blockAction.vue?vue&type=script&lang=js"
export * from "./blockAction.vue?vue&type=script&lang=js"
import style0 from "./blockAction.vue?vue&type=style&index=0&id=c38cfbba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports